import template from './auth.html';
import controller from './auth.controller';
import './auth.styl';

const AuthComponent = {
    template,
    controller,
    controllerAs: 'auth'
};

export default AuthComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/auth/auth.component.js
 **/